import { type TranslationTree } from '@/i18n/types';

export const messages = {
  brandTag: 'Partners',
  profileMenu: 'Menu do perfil',
  logout: 'Sair',
} satisfies TranslationTree;
